module.exports = __webpack_public_path__ + "static/media/wished.c2e27a8b.svg";